import { useEffect } from 'react';
import { UseFormWatch } from 'react-hook-form';
import { useDebounced } from 'v2/hooks/useDebounced';
import {
  ProposalEntity,
  SearchEntity,
  ProviderProposalResponseFields,
} from 'v2/models';
import { getProposalResponseProgressKey } from 'v2/utils/proposalUtils';

const useStoreProposal = (
  proposal: ProposalEntity,
  watch: UseFormWatch<ProviderProposalResponseFields>
) => {
  const search = proposal.search as SearchEntity;

  const { debounced: savedResponseDebounced } = useDebounced(
    (value) =>
      localStorage.setItem(
        getProposalResponseProgressKey(proposal.id, search.id),
        JSON.stringify(value)
      ),
    500
  );

  useEffect(() => {
    const subscription = watch(savedResponseDebounced);
    return () => subscription.unsubscribe();
  }, []);
};

export default useStoreProposal;
